module.exports = __webpack_public_path__ + "static/media/japan06.6c04dad7.jpg";